import { proxyFetch as fetch } from '@rss-engineering/fabric-ui-session';

const proxyFetch = (url, options) => {
  return fetch(url, { authenticateOnStatusCodes: [401], ...options })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw new Error(error);
    });
};

export { proxyFetch };
